import {
    createComponents,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { ICON_TEXT_BASE_CLASSNAME } from '@vfde-brix/ws10/icon-text';
import { createIconTextBannerComponent } from '@vfde-brix/ws10/icon-text-banner';

const SELECTOR_ICON_TEXT_BANNERS = `.${ICON_TEXT_BASE_CLASSNAME}-banner`;

/**
 * Mounts WS10 Icon Text Banner components.
 */
export const mountIconTextBanners = () =>
    createComponents(SELECTOR_ICON_TEXT_BANNERS, createIconTextBannerComponent, NO_PATTERN_BUSINESS_LOGIC);
